module.exports = __webpack_public_path__ + "img/2021.4e485b9a.svg";